import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Divider, Stack, Typography } from "@mui/material";

import {
  useGetNotifications,
  usePutMarkAllRead,
  useDeleteDismissAllRead,
} from "../../hooks/react-query/useNotificationsData";

import NotificationItem from "./NotificationItem";
import { usePutMarkRead } from "../../hooks/react-query/useNotificationsData";
import { HubButton } from "../inputs";

const NotificationMenu = ({ onClose }) => {
  const navigate = useNavigate();
  const { data: notifications } = useGetNotifications({ limit: 15 });
  const { mutate: markRead } = usePutMarkRead();
  const { mutate: markAllRead } = usePutMarkAllRead();
  const { mutate: dismissAllRead } = useDeleteDismissAllRead();

  const handleSeeAll = () => {
    onClose();
    navigate("/notifications");
  };

  const handleMarkRead = (id) => markRead(id);

  return (
    <Stack
      sx={{
        width: "500px",
        height: "600px",
        maxHeight: "600px",
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        px="14px"
        py="10px"
      >
        <Typography variant="boldCaptionL" fontSize={14}>
          Notifications
        </Typography>
        <Stack direction="row" gap="12px">
          <HubButton
            size="xsmall"
            variant="text"
            color="neutral"
            icon="Check"
            onClick={() => markAllRead()}
            iconProps={{ size: "14px" }}
          />
          <HubButton
            size="xsmall"
            variant="text"
            color="neutral"
            icon="XCircle"
            onClick={() => dismissAllRead()}
            iconProps={{ size: "14px" }}
          />
        </Stack>
      </Stack>

      <Divider />

      <Stack sx={{ overflowY: "auto", p: "4px" }}>
        {!notifications?.length && (
          <Typography
            variant="caption"
            fontSize={11}
            color="text.secondary"
            textAlign="center"
            py="24px"
          >
            No notifications
          </Typography>
        )}
        {notifications?.map((delivery) => (
          <NotificationItem
            key={delivery.id}
            delivery={delivery}
            onRead={handleMarkRead}
            onNavigate={onClose}
          />
        ))}
      </Stack>

      <Stack
        px="14px"
        py="12px"
        borderTop="1px solid"
        borderColor="hubColors.greyLight"
        mt="auto"
      >
        <Button
          size="small"
          variant="text"
          color="neutral"
          onClick={handleSeeAll}
          sx={{ fontSize: 10, textTransform: "none", alignSelf: "center" }}
        >
          View All Notifications
        </Button>
      </Stack>
    </Stack>
  );
};

export default NotificationMenu;
